module.exports = __webpack_public_path__ + "img/mark_foot_lower_image.f81a184c.svg";